import React from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { MealPlanKind, type MealPlan } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import { useApacHotelsStyles } from "../../hooks";
import { ApacHotelsComponent } from "../../types";
import defaultStyles from "./styles.module.scss";

interface RoomFeaturesProps {
  mealPlan?: MealPlan;
  cancellationPolicyText?: string;
  className?: string;
}

export const RoomFeatures: React.FC<RoomFeaturesProps> = ({
  cancellationPolicyText,
  mealPlan,
  className,
}) => {
  const { t } = useI18nContext();
  const COMPONENT_KEY = ApacHotelsComponent.RoomFeatures;
  const styles = useApacHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { kind: mealType } = mealPlan ?? {};

  /**
   * Possible strings for meal types are as follows ( needed for localization ):
   * - RoomOnly: t("hotelShop.mealPlan.RoomOnly")
   * - Breakfast: t("hotelShop.mealPlan.Breakfast")
   * - HalfBoard: t("hotelShop.mealPlan.HalfBoard")
   * - FullBoard: t("hotelShop.mealPlan.FullBoard")
   * - AllInclusive: t("hotelShop.mealPlan.AllInclusive")
   * - BreakfastFor1: t("hotelShop.mealPlan.BreakfastFor1")
   * - BreakfastFor2: t("hotelShop.mealPlan.BreakfastFor2")
   * - Lunch: t("hotelShop.mealPlan.Lunch")
   * - Dinner: t("hotelShop.mealPlan.Dinner")
   */
  const features = [
    ...(cancellationPolicyText ? [cancellationPolicyText] : []),
    ...(mealType && mealType !== MealPlanKind.RoomOnly
      ? [t(`hotelShop.mealPlan.${mealType}`)]
      : []),
  ];

  if (features.length <= 0) {
    return null;
  }

  return (
    <div className={clsx(block, className)}>
      {features.map((feature) => (
        <div className={cn("feature")}>{feature}</div>
      ))}
    </div>
  );
};
